import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    hotelLatam: null,
    lastError: null
};

export const hotelLatamSlice = createSlice({
    name: "hotelLatam",
    initialState: initialState,
    reducers: {

        catchError: (state, action) => {
            state.error = { ...action.payload.error };
            state.loading = false;
        },

        startCall: (state, action) => {
            state.error = null;
            state.loading = true;
        },

        hotelLatamFetched: (state, action) => {
            state.loading = false;
            state.error = null;
            state.hotelLatam = action.payload.hotelLatam;
        },
    }
});
